/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-29-10 08:00:00
 *
 *******************************************************/
// @flow
import React, { Component } from 'react';
import { SkeletonDisplayText } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import TableHeadingCellWithSort from './table-heading-cell-with-sort';
import TableRow from './table-row';

type Props = {
  skip: number,
  limit: number,
  sortId: number,
  isAsc: boolean,
  productRanking: Array<Object>,
  onSortProductRanking: Function,
  updateProductRankingField: Function,
  loading: boolean
};

type ComposedProps = Props & WithI18nProps;
// DONE
class ProductRanking extends Component<ComposedProps> {
  render() {
    // Render productRankings on table
    const rowsProductRanking = this.buildRows();
    const { loading, sortId, isAsc, i18n } = this.props;
    return (
      <div className="Polaris-DataTable">
        <div className="Polaris-DataTable__ScrollContainer">
          <table className="Polaris-DataTable__Table">
            <thead>
              <tr>
                {/*<TableHeadingCellWithSort
                  heading={i18n.translate('AdminHTML.ProductRanking.ProductRanking.tableHeadingCellWithSort1_Heading')}
                  isAsc={isAsc}
                  idSort={sortId}
                  id="id"
                  onSortProductRanking={this.onSortProductRanking}
                />*/}
                <th className="Polaris-DataTable__Cell Polaris-DataTable__Cell--header"></th>
                <TableHeadingCellWithSort
                  heading={i18n.translate(
                    'AdminHTML.ProductRanking.ProductRanking.tableHeadingCellWithSort2_Heading'
                  )}
                  isAsc={isAsc}
                  idSort={sortId}
                  id="title"
                  onSortProductRanking={this.onSortProductRanking}
                />
                <TableHeadingCellWithSort
                  heading={i18n.translate(
                    'AdminHTML.ProductRanking.ProductRanking.tableHeadingCellWithSort3_Heading'
                  )}
                  isAsc={isAsc}
                  idSort={sortId}
                  id="type"
                  onSortProductRanking={this.onSortProductRanking}
                />

                <th className="Polaris-DataTable__Cell Polaris-DataTable__Cell--header">
                  {i18n.translate('AdminHTML.ProductRanking.ProductRanking.tableHeading4')}
                </th>
              </tr>
            </thead>

            {loading ? (
              <tbody>
                {[...Array(5).keys()].map((item, key) => (
                  <React.Fragment key={key}>
                    <tr>
                      {[...Array(5).keys()].map((item, key) => (
                        <td className="Polaris-DataTable__Cell" key={key}>
                          <SkeletonDisplayText size="small" />
                        </td>
                      ))}
                    </tr>
                    <tr></tr>
                  </React.Fragment>
                ))}
              </tbody>
            ) : (
              <tbody className="list-available">{rowsProductRanking}</tbody>
            )}
          </table>
        </div>
      </div>
    );
  }

  // Render rows for data table
  buildRows = () => {
    const { fields, productRanking, appLanguage } = this.props;

    let rows = fields.map((item, index) => {
      return (
        <TableRow
          productRanking={productRanking}
          item={item}
          index={index}
          onChooseDate={this.onChooseDate}
          key={index}
          appLanguage={appLanguage}
        />
      );
    });
    return rows;
  };

  // Handle click sort
  onSortProductRanking = (sortId, isAsc) => {
    const { onSortProductRanking } = this.props;

    onSortProductRanking(sortId, isAsc);
  };

  // Handle change date range
  onChooseDate = (index, selectedDate, selectedDateRange) => {
    const { updateProductRankingField } = this.props;
    let { start, end } = selectedDate;
    if (selectedDateRange === 'none') {
      // No time limit
      start = null;
      end = null;
    }
    updateProductRankingField(index, 'enabledFromDate', start);
    updateProductRankingField(index, 'enabledToDate', end);
  };
}

export default withI18n()(ProductRanking);
